export const SETTINGS = {
        adminPage: 'admin-settings-page',
        tabGeneral: 'settings-tab-general',
        tabSeo: 'settings-tab-seo',
        tabTracking: 'settings-tab-tracking',
        saveBtn: 'admin-settings-save',
        siteName: 'settings-site-name',
        logoUrl: 'settings-logo-url',
        faviconUrl: 'settings-favicon-url',
        supportWa: 'settings-support-wa',
        metaPixel: 'settings-meta-pixel',
        tiktokPixel: 'settings-tiktok-pixel',
};
